import React from 'react';
import { Redirect, Stack } from 'expo-router';
import { observer } from '@legendapp/state/react';
import { globalState } from '@/state/globalState';
import { canManageCompanyUsers } from '@/utils/userRoles';

// Layout para a seção de usuários
function UsersLayout() {
  const userType = globalState.user.profile.get()?.user_type;

  if (!canManageCompanyUsers(userType)) {
    return <Redirect href="/(app)/settings" />;
  }

  return (
    <Stack>
      <Stack.Screen 
        name="index" 
        options={{ 
          headerShown: false
        }} 
      />
      <Stack.Screen 
        name="new" 
        options={{ 
          headerShown: false
        }} 
      />
      <Stack.Screen 
        name="[id]" 
        options={{ 
          headerShown: false
        }} 
      />
    </Stack>
  );
}

export default observer(UsersLayout);
